<template>
	<!-- Button, um neuen Step am Ende hinzuzufügen -->
	<IconBase v-if="large" class="icon big"
			  iconName="Step hinzufügen"
			  width="45"
			  height="45"
			  viewBox="-5 -1 80 70">
		<IconNew/>
	</IconBase>
	<!-- Button, um neuen Step zwischendrin einzuzufügen -->
	<IconBase v-else class="icon small"
			  iconName="Step einfügen"
			  width="35"
			  height="35"
			  viewBox="-5 -1 80 70">
		<IconNew/>
	</IconBase>
</template>

<script>
	import IconBase from '@/components/icons/IconBase.vue';
	import IconNew from '@/components/icons/IconNew.vue';

	export default {
		name: "ShowEditAddStep",
		components: {
			IconNew,
			IconBase
		},
		props: ["large"]
	}
</script>

<style scoped>

	

	.small {
		stroke: white;
		background-color: black;
		margin-top: 108px;
	}

	.big {
		stroke: black;
		background-color: #F2F2F2;
	}

	.big:hover {
		stroke: white;
		background-color: black;
	}

</style>